export const getDescriptionId = (id) => id ? `${id}-description` : undefined;
export const getLabelId = (id) => `${id}-label`;
export const mergeAriaIds = (...ids) => ids.filter(Boolean).join(' ') || undefined;
// Destructuring loses the union narrowing, so rebuild it for the child component.
export const toLabelled = (label, ariaLabel, ariaLabelledBy) => ({
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledBy,
    label,
});
